// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first_block_layout{
    position: absolute;
    z-index: 1;
    
}
.second_block_layout {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 93%;
    pointer-events: none;
}

.element1 {
    position: absolute;
    top: 10px;
    left: 50px;
    pointer-events: auto;
}

.element2 {
    position: absolute;
    top: 10px;
    right: 10px;
    pointer-events: auto;
}

.element3 {
    position: absolute;
    bottom: 10px;
    right: 10px;
    pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/personal/main_page.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;;AAEd;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB","sourcesContent":[".first_block_layout{\r\n    position: absolute;\r\n    z-index: 1;\r\n    \r\n}\r\n.second_block_layout {\r\n    position: absolute;\r\n    z-index: 2;\r\n    width: 100%;\r\n    height: 93%;\r\n    pointer-events: none;\r\n}\r\n\r\n.element1 {\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 50px;\r\n    pointer-events: auto;\r\n}\r\n\r\n.element2 {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    pointer-events: auto;\r\n}\r\n\r\n.element3 {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    right: 10px;\r\n    pointer-events: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
